import {
  SET_FS_GAME_NAMES,
  SET_FS_GAME_IMAGES,
  SET_FS_GAME_POLA,
  SET_GAME_ISLOADING,
  SET_GAME_ISERROR
} from '../actionTypes';

const initialState = {
  fsNames: [],
  fsImages: [],
  fsPolas: [],
  nameAndImagesIsLoading: true,
  isError: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FS_GAME_NAMES:
      return { ...state, fsNames: action.payload }
    case SET_FS_GAME_IMAGES:
      return { ...state, fsImages: action.payload };
    case SET_FS_GAME_POLA:
      return { ...state, fsPolas: action.payload };
    case SET_GAME_ISLOADING:
      return { ...state, nameAndImagesIsLoading: action.payload };
    case SET_GAME_ISERROR:
      return { ...state, isError: action.payload };
    default:
      return state;
  };
};

export default reducer;